import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
        <h2>Who We Are</h2>
        <p>
        Our experience enables us to offer effective outpatient, individualized, psychological care including medication management, psychotherapy, and nutritional consulting.  We treat many mental health disorders, and provide client-centered treatment to individuals, families, and couples.
        </p>
        <p>
        "Sound Mind Sound Body" is named after a quote by a Greek philosopher, who recognized the close links between physical and mental health and the ability to enjoy life.  Achieving harmony between the brain and body is essential to whole body wellness. Our integrative approach identifies and treats core imbalances which affect your brain, body, and quality of life.
        </p>
        <p>
        It is our goal to enhance your overall mental health by optimizing the inseparable mind-body connection.  Our goal is to help you grow from your struggles, heal from your pain, and move forward in living your best life through psychiatric medication management, psychotherapy, and nutrition & fitness coaching.
        </p>

        <a
          href="https://g.co/kgs/qfoZc3Y"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit our Office
        </a> 

        <br />
        <br />
      </Wrap>
    </>
  );
};

export default Content;
